import React from 'react';
import style from './style.scss';
import { I18n } from '@ies/starling_intl';

interface Props {
  postTemplate(): void;
}

export default function PostTemplate(props: Props) {
  const { postTemplate } = props;
  return (
    <div onClick={postTemplate} className={style.wrap}>
      {I18n.t('open_capcut')}
    </div>
  );
}
